import templateStr from 'text!./templates/back-button.html';
import 'portalConfig';

export default () => {
    return {
        restrict: 'A',
        template: templateStr,
        scope: {
            title: '@'
        },
        controller: ['$scope', ($scope) => {
            $scope.goBack = () => {
                window.history.back();
            };
        }]
    };
};